import { Point } from "pixi.js";

export const PointerState = new Point(0, 0);